import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatChipsModule } from '@angular/material/chips';
import { AccountModel } from '../../../../../../domain/models/account.model';
import { AccountContentService } from '../../../../../../domain/services/account-content/account-content.service';

/** Account-scoped HISTORY (audit) tab. */
@Component({
  selector: 'app-account-history-tab',
  standalone: true,
  imports: [CommonModule, MatTableModule, MatChipsModule],
  templateUrl: './account-history-tab.component.html',
  styleUrl: './account-history-tab.component.css'
})
export class AccountHistoryTabComponent implements OnInit {
  @Input() account!: AccountModel;

  history: any[] = [];
  displayedColumns = ['timestamp', 'actionType', 'userName', 'description'];
  loadError: string | null = null;

  constructor(private contentService: AccountContentService) {}

  ngOnInit(): void {
    this.loadHistory();
  }

  loadHistory(): void {
    if (!this.account?.id) { return; }
    this.contentService.getHistory(this.account.id).subscribe({
      next: (rows) => { this.history = rows; },
      error: (err) => { console.error('Error loading history:', err); this.loadError = 'Unable to load history.'; }
    });
  }

  typeClass(actionType: string): string {
    switch (actionType) {
      case 'EDIT': return 'type-edit';
      case 'NOTE': return 'type-note';
      case 'ATTACHMENT': return 'type-attachment';
      case 'STATUS_CHANGE': return 'type-status';
      default: return '';
    }
  }
}
